import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';
import { PagedResult } from '../models/product.model';
import { Order, OrderListItem, OrderQuery } from '../models/order.model';

@Injectable({ providedIn: 'root' })
export class OrderService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${API_BASE_URL}/orders`;

  getPaged(query: OrderQuery = {}): Observable<PagedResult<OrderListItem>> {
    let params = new HttpParams();
    if (query.search?.trim()) params = params.set('search', query.search.trim());
    if (query.status) params = params.set('status', query.status);
    if (query.page) params = params.set('page', query.page);
    if (query.pageSize) params = params.set('pageSize', query.pageSize);
    if (query.sort) params = params.set('sort', query.sort);
    return this.http.get<PagedResult<OrderListItem>>(this.baseUrl, { params });
  }

  getById(id: string): Observable<Order> {
    return this.http.get<Order>(`${this.baseUrl}/${id}`);
  }

  getReceiptBySession(sessionId: string): Observable<Order> {
    const params = new HttpParams().set('session_id', sessionId);
    return this.http.get<Order>(`${this.baseUrl}/receipt`, { params });
  }

  downloadReceiptPdfBySession(sessionId: string): Observable<Blob> {
    const params = new HttpParams().set('session_id', sessionId);
    return this.http.get(`${this.baseUrl}/receipt/pdf`, {
      params,
      responseType: 'blob'
    });
  }

  downloadAdminPdf(id: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/${id}/admin-pdf`, {
      responseType: 'blob'
    });
  }
}
